export const PageHero = ({ eyebrow, title, children, testid }) => (
  <section className="relative overflow-hidden border-b border-slate-800 bg-[#0B0F17] grid-bg" data-testid={testid}>
    <div className="pointer-events-none absolute -left-20 top-0 h-full w-1/2 bg-[radial-gradient(ellipse_at_left,rgba(220,38,38,.12),transparent_60%)]" />
    <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 md:py-20">
      <p className="eyebrow fade-up"><span className="h-px w-8 bg-red-500" />{eyebrow}</p>
      <h1 className="fade-up mt-4 max-w-4xl text-4xl font-bold uppercase leading-[1.05] text-white sm:text-5xl lg:text-6xl" style={{ animationDelay: "80ms" }}>
        {title}
      </h1>
      {children && <div className="fade-up mt-5 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg" style={{ animationDelay: "160ms" }}>{children}</div>}
    </div>
  </section>
);

export const SectionTitle = ({ eyebrow, title, sub }) => (
  <div className="mb-10">
    <p className="eyebrow"><span className="h-px w-8 bg-red-500" />{eyebrow}</p>
    <h2 className="mt-3 text-2xl font-bold uppercase text-white sm:text-3xl lg:text-4xl">{title}</h2>
    {sub && <p className="mt-3 max-w-2xl text-base text-slate-400 md:text-lg">{sub}</p>}
  </div>
);
